import { CacheConfig, REQUEST_SOURCE } from '../base/define';
import { formatLoginPanda, formatYoudaoUser, formatOrderArray } from './format';

const { protocol } = window.location;
const youdaoPrefixUrl = `${protocol}//dict.youdao.com/login/acc`;

const config: CacheConfig = {
  'login-youdao': {
    url: `${youdaoPrefixUrl}/login`,
    method: 'get',
    source: REQUEST_SOURCE.YOUDAO,
  },
  'get-youdao-login-info': {
    url: `${youdaoPrefixUrl}/co/cq`,
    method: 'get',
    source: REQUEST_SOURCE.YOUDAO,
    format: formatYoudaoUser,
  },
  'logout-youdao': {
    url: `${youdaoPrefixUrl}/se/reset?app=web&product=DICT&newjson=true`,
    method: 'get',
  },
  'login-panda': {
    url: '/api/steam/user/login',
    method: 'post',
    format: formatLoginPanda,
  },
  'logout-panda': {
    url: '/api/steam/user/logout',
    method: 'post',
  },
  'account-cancellation': {
    url: '/api/steam/user/cancellation',
    method: 'post',
  },
  'get-user-list': {
    url: '/api/admin/steam/user/search',
    method: 'get',
    showLoading: true,
  },
  'get-user-course-list': {
    url: '/api/admin/steam/user/course/list',
    method: 'get',
  },
  'get-user-order-list': {
    url: '/api/admin/steam/user/order/list',
    method: 'get',
  },
  'get-user-order-array': {
    url: '/api/admin/steam/user/history/orderList',
    method: 'get',
    format: formatOrderArray,
  },
  'get-user-binding-order-list': {
    url: '/api/admin/steam/order/getBindingOrderList',
    method: 'get',
    format: formatOrderArray,
  },
  'get-user-address': {
    url: '/api/steam/user/delivery/get',
    method: 'get',
  },
  'update-user-address': {
    url: '/api/steam/user/delivery/addOrUpdate',
    method: 'post',
  },
  'get-user-detail': {
    url: '/api/admin/steam/user/detail',
    method: 'get',
  },
  'get-user-integral': {
    url: '/api/steam/user/integral/remain',
    method: 'get',
  },
  'get-user-info': {
    url: '/api/steam/user/loginUserInfo',
    method: 'get',
    format: formatLoginPanda,
  },
  'get-user-info-pure': {
    url: '/api/steam/user/userInfo',
    method: 'get',
    format: formatLoginPanda,
  },
  'export-list': {
    url: '/api/admin/steam/user/search/export',
    method: 'get',
  },
  'export-list-process': {
    url: '/api/admin/steam/user/search/export/process',
    method: 'get',
  },
  'get-team-info': {
    url: '/api/admin/steam/team/getTeamInfo',
    method: 'get',
  },
  'get-teacher-info': {
    url: '/api/steam/team/getTeachInfo',
    method: 'get',
  },
  'get-sms-code-flag': {
    url: '/api/steam/sms/getSmsCodeFlag',
    method: 'get',
  },
  'send-sms': {
    url: '/api/steam/sms/send',
    method: 'post',
  },
  'get-user-member-list': {
    url: '/api/admin/steam/user/vip/getVipRecord',
    method: 'get',
  },
  'on-or-off-vip': {
    url: '/api/admin/steam/user/vip/onOrOffVip',
    method: 'post',
  },
  'get-user-learn-report-total-statistic': {
    url: '/api/steam/admin/user/learn/report/totalStatistic',
    method: 'get',
  },
  'get-user-learn-report-day-list': {
    url: '/api/steam/admin/user/learn/report/dayList',
    method: 'get',
  },
  'get-user-learn-report-daily-unit-list': {
    url: '/api/steam/admin/user/learn/report/dailyUnitList',
    method: 'get',
  },
  'get-user-contact-list': {
    url: '/api/steam/admin/contact/list',
    method: 'get',
  },
  'add-user-contact': {
    url: '/api/steam/admin/contact/add',
    method: 'post',
  },
};

export default config;
